"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancellationPromise = void 0;
class CancellationPromise {
    constructor(autoRenew = false) {
        this.autoRenew = autoRenew;
        this.promise = new Promise((resolve) => this.resolve = resolve);
    }
    cancel(value) {
        if (!this.promise) {
            throw new Error("Already cancelled");
        }
        this.resolve(value);
        if (this.autoRenew) {
            this.promise = new Promise((resolve) => this.resolve = resolve);
            return;
        }
        this.promise = null;
        this.resolve = null;
    }
    with(promise) {
        return Promise.race([this.promise, promise]);
    }
}
exports.CancellationPromise = CancellationPromise;
//# sourceMappingURL=module.js.map
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibW9kdWxlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vbW9kdWxlLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxNQUFhLG1CQUFtQjtJQUk1QixZQUNhLFlBQXFCLEtBQUs7UUFBMUIsY0FBUyxHQUFULFNBQVMsQ0FBaUI7UUFFbkMsSUFBSSxDQUFDLE9BQU8sR0FBRyxJQUFJLE9BQU8sQ0FBQyxDQUFDLE9BQU8sRUFBRSxFQUFFLENBQUMsSUFBSSxDQUFDLE9BQU8sR0FBRyxPQUFPLENBQUMsQ0FBQztJQUNwRSxDQUFDO0lBRUQsTUFBTSxDQUFDLEtBQVE7UUFDWCxJQUFJLENBQUMsSUFBSSxDQUFDLE9BQU8sRUFBRTtZQUNmLE1BQU0sSUFBSSxLQUFLLENBQUMsbUJBQW1CLENBQUMsQ0FBQztTQUN4QztRQUVELElBQUksQ0FBQyxPQUFPLENBQUMsS0FBSyxDQUFDLENBQUM7UUFFcEIsSUFBSSxJQUFJLENBQUMsU0FBUyxFQUFFO1lBQ2hCLElBQUksQ0FBQyxPQUFPLEdBQUcsSUFBSSxPQUFPLENBQUMsQ0FBQyxPQUFPLEVBQUUsRUFBRSxDQUFDLElBQUksQ0FBQyxPQUFPLEdBQUcsT0FBTyxDQUFDLENBQUM7WUFDaEUsT0FBTztTQUNWO1FBRUQsSUFBSSxDQUFDLE9BQU8sR0FBRyxJQUFLLENBQUM7UUFDckIsSUFBSSxDQUFDLE9BQU8sR0FBRyxJQUFLLENBQUM7SUFDekIsQ0FBQztJQUVELElBQUksQ0FBUyxPQUF3QjtRQUNqQyxPQUFPLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQyxJQUFJLENBQUMsT0FBTyxFQUFFLE9BQU8sQ0FBQyxDQUFDLENBQUM7SUFDakQsQ0FBQztDQUVKO0FBOUJELGtEQThCQyJ9